import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import { RoleModule } from '@blade-sxp/account/store/role';
import { mapTree } from '@blade-sxp/account/utils/map-tree';
import RoleTree from './components/role-tree.vue';
import { handleError } from '@blade/common/utils/handle-error';
import { filter, includes } from 'lodash';
import { setCodeList } from './utils';
const DisplayCodesGroup = ['00', '07'];
let default_1 = class default_1 extends Vue {
    radio = 3;
    listLoading = false;
    form = {
        dynamicError: {
            org_type: '',
        },
        name: '',
        organization: '',
        permissions: [],
        demo_role: false,
    };
    displayCodes = [];
    get roleRules() {
        return {
            name: [
                {
                    required: true,
                    trigger: ['blur', 'change'],
                    validator: (rule, value, callback) => {
                        const emptyRegex = /^\s/;
                        if (!this.form.name || emptyRegex.test(this.form.name)) {
                            return callback(new Error(this.$t('selectRole').toString()));
                        }
                        callback();
                    },
                },
            ],
            org_type: [
                {
                    required: true,
                    trigger: ['change', 'blur'],
                    validator: (rule, value, callback) => {
                        const treeNode = this.$refs.permissionTree;
                        const nodeChecked = treeNode.getCheckedKeys();
                        if (!(nodeChecked.length > 0) && !this.form.demo_role) {
                            this.form.dynamicError.org_type = this.$t('selectPermission');
                            callback(new Error(this.form.dynamicError.name));
                        }
                        else {
                            this.form.dynamicError.org_type = '';
                            callback();
                        }
                    },
                },
            ],
        };
    }
    title = '';
    roleTree = [];
    demoRoleTree = [];
    mode = 'CREATE';
    id = '';
    defaultExpandedKeys = [];
    async mounted() {
        const { meta } = this.$route;
        this.title = meta.page;
        const queryParam = this.$route.params;
        this.id = queryParam?.id ?? '';
        await this.getPermissions();
        if (this.title === 'roleEdit') {
            this.mode = 'EDIT';
            await this.getData();
        }
    }
    async getData() {
        if (!this.id) {
            return;
        }
        try {
            const { name, permissions, type } = await RoleModule.getRoleDetail(this.id);
            this.form.name = name;
            this.form.demo_role = type === 'DEMO_ROLE';
            this.mapCode(permissions);
        }
        catch (error) {
            this.$elmessage({ type: 'error', message: error });
        }
    }
    setDemoTree(res) {
        this.displayCodes = [];
        setCodeList(filter(res, item => includes(DisplayCodesGroup, item.code)), this.displayCodes);
        this.demoRoleTree = mapTree(res, true);
        this.$refs.demoPermissionTree.setCheckedKeys(this.displayCodes);
    }
    async getPermissions() {
        this.listLoading = true;
        try {
            const res = await RoleModule.getPermissions();
            this.setDemoTree(res);
            const mappedOrg = mapTree(res);
            this.roleTree = mappedOrg;
        }
        catch (error) {
            this.$elmessage({ type: 'error', message: error });
        }
        finally {
            this.listLoading = false;
        }
    }
    handleCancel() {
        this.$router.replace('/users/role');
    }
    getCheckedKeys() {
        if (this.form.demo_role) {
            this.form.permissions = this.displayCodes;
        }
        else {
            const treeNode = this.$refs.permissionTree;
            const nodeChecked = treeNode.getCheckedKeys();
            const onlyhalfChecked = treeNode.getHalfCheckedKeys();
            const allChecked = [...onlyhalfChecked, ...nodeChecked];
            this.form.permissions = allChecked;
        }
    }
    handleSubmit() {
        this.getCheckedKeys();
        this.$refs['roleForm'].validate(async (valid) => {
            if (valid) {
                if (this.mode === 'CREATE') {
                    this.createRole();
                }
                else {
                    this.editRole();
                }
            }
            else {
                console.log('invalid:');
                return false;
            }
        });
    }
    async createRole() {
        try {
            const { demo_role } = this.form;
            await RoleModule.createRole({
                id: this.id,
                permission_code: this.form.permissions,
                role_name: this.form.name.trim(),
                demo_role,
            });
            this.$elmessage.success(this.$t('successCreate').toString());
            this.$router.push('/users/role');
        }
        catch (e) {
            if (e.messages) {
                this.$elmessage.error(e.messages);
            }
            else {
                handleError(e);
            }
        }
    }
    async editRole() {
        try {
            const { demo_role } = this.form;
            await RoleModule.updateRoleDetail({
                id: this.id,
                permission_code: this.form.permissions,
                role_name: this.form.name.trim(),
                demo_role,
            });
            this.$elmessage.success(this.$t('successEdit').toString());
            this.$router.push('/users/role');
        }
        catch (e) {
            if (e.messages) {
                this.$elmessage.error(e.messages);
            }
            else {
                handleError(e);
            }
        }
    }
    flattenCode(data, flatted) {
        data.forEach((item) => {
            flatted.push(item.id);
            if (item.children?.length > 0) {
                this.flattenCode(item.children, flatted);
            }
        });
    }
    mapCode(codes) {
        const res = [];
        this.getCheckedCodes(codes, res);
        this.$refs.permissionTree.setCheckedKeys(res);
        this.defaultExpandedKeys.push(...res);
    }
    getCheckedCodes(data, flatted) {
        data.forEach(item => {
            if (item.enable && this.isLeaf(item.code)) {
                flatted.push(item.code);
            }
            if (item.subPermissions?.length > 0) {
                this.getCheckedCodes(item.subPermissions, flatted);
            }
        });
    }
    // 判断是否为叶子节点
    isLeaf(id) {
        const tree = this.$refs.permissionTree;
        const node = tree.getNode(id);
        return node?.isLeaf;
    }
    beforeDestroy() {
        this.mode = 'CREATE';
    }
    async onLocaleChange(newVal) {
        this.$refs['roleForm']?.clearValidate();
        await this.getPermissions();
        this.getData();
    }
};
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "onLocaleChange", null);
default_1 = __decorate([
    Component({
        name: 'RoleEdit',
        components: { RoleTree },
        i18n: {
            messages: {
                'en-us': {
                    roleCreate: 'Create',
                    cancel: 'Cancel',
                    roleEdit: 'Edit',
                    roleName: 'Role Name',
                    displayRole: 'Is a display mode role',
                    roleOrganization: 'Role Organization',
                    submit: 'Submit',
                    orgType: 'Account Permissions',
                    selectRole: 'Please input role name',
                    selectPermission: 'Please select permissions',
                    successCreate: 'Successfully create role',
                    successEdit: 'Successfully edit role',
                },
                zh: {
                    roleCreate: '创建角色',
                    cancel: '取消',
                    roleEdit: '角色编辑',
                    roleName: '角色名字',
                    displayRole: '是否为演示模式角色',
                    roleOrganization: '角色组织',
                    submit: '提交',
                    orgType: '业务权限配置',
                    selectRole: '请输入角色',
                    selectPermission: '请选择权限',
                    successCreate: '成功创建角色',
                    successEdit: '成功更新角色',
                },
            },
        },
    })
], default_1);
export default default_1;
